/* eslint-disable guard-for-in */
/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
import { isEmpty } from 'lodash';

const cleanupFormValues = <D extends Record<string, any>>(
  data: D,
  mode: 'soft' | 'hard' = 'soft'
) => {
  if (data && typeof data === 'object' && Object.keys(data)) {
    const result = { ...data };
    for (const key in result) {
      const item = data[key];
      if (item === '' || item === undefined) {
        delete result[key];
        continue;
      }
      if (Array.isArray(item)) {
        if (mode === 'hard' && !item.length) {
          delete result[key];
          continue;
        } else {
          result[key] = item.filter((arrayItem: any) => arrayItem !== undefined);
          continue;
        }
      }
      if (item && typeof item === 'object') {
        if (mode === 'hard' && isEmpty(item)) {
          delete result[key];
          continue;
        } else {
          result[key] = cleanupFormValues(item, mode);
        }
      }
    }
    return result;
  }
  return data;
};

export default cleanupFormValues;
